import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';
import {testIds} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {useVehiclesActionCallback} from '../../hooks/useVehiclesActionCallback';

export function VehiclesOverview() {
  const [actionCallback] = useVehiclesActionCallback();

  return (
    <DmsDataGrid
      gridCode={
        (isFeatureEnabled(featureFlags.SALES_360_VEHICLES) &&
          !isFeatureEnabled(featureFlags.REPLACE_VEHICLE_DG_WITH_OPENSEARCH)) ||
        isFeatureEnabled(featureFlags.REPLACE_VEHICLE_DG_WITH_OPENSEARCH)
          ? 'vehicle-opensearch'
          : 'vehicle'
      }
      // eslint-disable-next-line no-restricted-syntax
      key="vehicle"
      data-testid={testIds.vehicles.home()}
      actionCallback={actionCallback}
    />
  );
}
